import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthService, FIREBASE_AUTH_INSTANCE } from './auth.service'
import { LoginComponent } from './ui/login.component'
import { PasswordResetComponent } from './ui/password-reset.component';
import { PasswordResetConfirmComponent } from './ui/password-reset-confirm.component';
import { PublicComponent } from './ui/public.component';

export type AsyncProvider = {
	deps?: any[];
	useFactory: (...args: any[]) => any;
};

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		RouterModule,
		MatCardModule,
		MatButtonModule,
		MatProgressSpinnerModule,
		MatFormFieldModule,
		MatInputModule,
		LoginComponent,
		PasswordResetComponent,
		PasswordResetConfirmComponent,
		PublicComponent,
	],
	exports: [LoginComponent, PasswordResetComponent, PasswordResetConfirmComponent, PublicComponent],
})
export class AuthModule {
	static forRootAsync(authProvider: AsyncProvider): ModuleWithProviders<AuthModule> {
		return {
			ngModule: AuthModule,
			providers: [
				{
					provide: FIREBASE_AUTH_INSTANCE,
					useFactory: authProvider.useFactory,
					deps: authProvider.deps || [],
				},
				AuthService,
			],
		};
	}
}
